import mapRelationship from '@/utils/mapRelationship'

const BLANK = { headerText: '', buttonText: '' }

// Merchants set these two strings on their UpsellCategory. Defaults belong to UpsellModal, so a
// merchant who left the copy blank reads as blank here rather than picking up someone else's wording.
function copyFromAttributes(attributes) {
  if (!attributes) return { ...BLANK }
  return {
    headerText: attributes.upsell_header_text || '',
    buttonText: attributes.upsell_button_text || ''
  }
}

// V1 serves upsells as category-product-store-pairs; the category rides along in `included` and is
// reachable only through the relationship on one of them.
export function upsellCopyFromCpsps(state, categoryProductStorePairs) {
  const category = mapRelationship(state, categoryProductStorePairs?.[0]?.relationships?.category?.data)
  return copyFromAttributes(category?.attributes)
}

// V2 gets the upsell category inline on the store payload, already flattened.
export function upsellCopyFromCategory(category) {
  return copyFromAttributes(category)
}
